<template>
  <div class="treebox-list" @click.stop="treeboxShow">
    <div
      class="treebox-list-item"
      v-for="(item, index) in searchDataList"
      :key="index"
    >
      <div class="treebox-list-item-title">
        {{ item.twoLayersName }}
      </div>
      <span class="select-btn" @click="selectClick(item)">添加</span>
    </div>
    <div class="mt20" v-if="total > 10">
      <el-pagination
        v-model="paramsList.current"
        :total="total"
        size="small"
        :page-size="paramsList.size"
        @current-change="onChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "tree-search",
  props: {
    searchDataList: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 0
    },
    paramsList: {
      type: Object,
      default: {
        current: 0,
        size: 10
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    treeboxShow() {
      this.$emit("treeboxShow");
    },
    selectClick(item) {
      //编辑节点
      this.$emit("selectClick", item);
    },
    onChange(pageNumber) {
      //分页
      this.$emit("changePage", pageNumber);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/style/addSample.less";
</style>